import { render } from "./chatbox.vue?vue&type=template&id=74ea0ef4&scoped=true"
import script from "./chatbox.vue?vue&type=script&lang=js"
export * from "./chatbox.vue?vue&type=script&lang=js"

import "./chatbox.vue?vue&type=style&index=0&id=74ea0ef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ea0ef4"]])

export default __exports__